module.exports = __webpack_public_path__ + "05_face.31c82d9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer1/05_face.png
// module id = MTLl
// module chunks = 0